import { Add } from "../../components/Add";

import { useEffect, useState } from "react";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import styles from "../../../styles/banners.module.scss";
import { Icon } from "../../components/core/Icon";
import BannersForm from "./BannersForm";
import BannersSort from "./BannersSort";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

const BannersDelivery = ({ banners, openSort, onCloseSort, onRefresh }) => {
  const [visible, setVisible] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [holdingId, setHoldingId] = useState(null);

  const getHoldingId = async () => {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    setHoldingId(holdingId);
  };

  useEffect(() => {
    getHoldingId();
  }, []);

  const environment = EnvironmentStorage.getEnvironment();

  const isCabana =
    environment?.brand?.alias === "cabana-burger779" ||
    environment?.alias === "cabana-burger779";

  const isCiaTC = holdingId && holdingId === 811;

  return (
    <div className={css({ delivery: true, cabana: isCabana, ciatc: isCiaTC })}>
      <div className={styles.header}>
        Desktop ({banners?.desktop?.length || 0})
      </div>
      <div className={styles.desktop}>
        {banners?.desktop?.map((banner, index) => {
          return (
            <div className={styles.banner} key={index}>
              <div className={styles.image}>
                <img
                  src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.image}`}
                  alt={banner.name}
                />

                <div
                  className={styles.edit}
                  onClick={() => {
                    setSelectedBanner(banner);
                    setSelectedDevice("desktop");
                    setVisible(true);
                  }}
                >
                  <Icon name="pen" size="lg" light color="#fff" />
                </div>
              </div>
              <div className={styles.details}>
                <p className={styles.name}>{banner?.name}</p>

                <div className={styles.icons}>
                  {banner?.link && <Icon name="link" light size="1x" />}
                  {banner?.visibility && (
                    <Icon name="calendar-day" light size="1x" />
                  )}
                </div>
              </div>
            </div>
          );
        })}
        <Add
          text="Adicionar banners"
          style={{ height: isCabana ? 300 : 150 }}
          className="flex-column"
          onClick={() => {
            setSelectedDevice("desktop");
            setVisible(true);
          }}
        />
      </div>
      <div className={styles.header}>
        Mobile ({banners?.mobile?.length || 0})
      </div>
      <div className={styles.mobile}>
        {banners?.mobile?.map((banner, index) => {
          return (
            <div className={styles.banner} key={index}>
              <div className={styles.image}>
                <img
                  src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.image}`}
                  alt={banner.name}
                />

                <div
                  className={styles.edit}
                  onClick={() => {
                    setSelectedBanner(banner);
                    setSelectedDevice("mobile");
                    setVisible(true);
                  }}
                >
                  <Icon name="pen" size="lg" light color="#fff" />
                </div>
              </div>
              <div className={styles.details}>
                <p className={styles.name}>{banner?.name}</p>

                <div className={styles.icons}>
                  {banner?.link && <Icon name="link" light size="1x" />}
                  {banner?.visibility && (
                    <Icon name="calendar-day" light size="1x" />
                  )}
                </div>
              </div>
            </div>
          );
        })}
        <Add
          text="Adicionar banners"
          style={{ height: isCabana ? 550 : isCiaTC ? 300 : 400 }}
          className="flex-column"
          onClick={() => {
            setSelectedDevice("mobile");
            setVisible(true);
          }}
        />
      </div>

      <BannersForm
        banners={banners}
        visible={visible}
        onClose={() => {
          setVisible(false);
          setSelectedBanner(null);
        }}
        onSave={() => onRefresh()}
        onDelete={() => {
          setVisible(false);
          setSelectedBanner(null);
          onRefresh();
        }}
        selectedBanner={selectedBanner}
        category={"delivery"}
        device={selectedDevice}
        dimensions={{
          desktop: isCabana
            ? { width: 2500, height: 600 }
            : { width: 1920, height: 400 },
          mobile: isCabana
            ? { width: 1080, height: 1920 }
            : isCiaTC
            ? { width: 1080, height: 500 }
            : { width: 1080, height: 500 },
        }}
      />

      <BannersSort
        visible={openSort}
        onClose={onCloseSort}
        title="Delivery"
        alias={"delivery"}
        category={banners}
        devices={[
          { key: "desktop", name: "Desktop" },
          { key: "mobile", name: "Mobile" },
        ]}
        onSave={() => {
          onRefresh();
          onCloseSort();
        }}
      />
    </div>
  );
};

export default BannersDelivery;
